<template>
  <div
    class="grid lg1024:grid-cols-3 grid-cols-1 lg1024:mt-4 lg1024:gap-4 gap-3 w-full xl1920:w-10/12"
    :class="[
      { 'delivery-types-ukraine': countryCode === 'UA' },
      { 'lg1024:mb-12 mb-6': activeId !== 'POST' },
    ]"
  >
    <div
      v-for="type in types"
      :key="type.ID"
      class="delivery-type__item"
      :class="[
        { 'active-delivery-type-item': activeId === type.ID },
        { 'type-courier': type.ID === 'COURIER' },
      ]"
      :data-qa="'step3-delivery-type-' + type.ID"
      @click="$emit('selectType', type)"
    >
      <img
        v-if="type.ID === 'COURIER'"
        src="@/assets/img/courier.svg"
        alt=""
        class="delivery-type__item-icon"
      />
      <img
        v-if="type.ID === 'PICK_POINT'"
        src="@/assets/img/pick-point.svg"
        alt=""
        class="delivery-type__item-icon"
      />
      <img
        v-if="type.ID === 'POST'"
        src="@/assets/img/post.svg"
        alt=""
        class="delivery-type__item-icon"
      />
      <div class="delivery-type__item-info">
        <h3 class="delivery-type__item-info-title">{{ type.NAME }}</h3>
        <div class="delivery-type__item-info-subtitle">
          <span
            :class="{
              'subtitle-comma': getMinimalPrice(type) !== $t('free_shipping'),
            }"
          >
            {{
              getTransitDaysForMinimapPrice(type)
                ? getTransitDaysForMinimapPrice(type)
                : $t('comfortable_day')
            }}
          </span>
          <p v-if="getMinimalPrice(type) !== $t('free_shipping')">
            {{ type.ITEMS.length > 1 ? $t('from') : '' }}
            {{ getMinimalPrice(type) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue'
import { declOfNumGlobal } from '@/utils/delivery.js'

const props = defineProps({
  types: { type: Array, required: true },
  activeId: { type: String, default: '' },
  countryCode: { type: String, required: true },
  currency: { type: String, required: true },
})

defineEmits(['selectType'])

const { proxy } = getCurrentInstance()

function getMinimalPrice(svc) {
  const lowest = svc.ITEMS.reduce((prev, curr) =>
    prev.PRICE < curr.PRICE ? prev : curr
  )
  if (lowest.PRICE > 0) {
    return new Intl.NumberFormat(props.countryCode, {
      style: 'currency',
      currency: props.currency,
      minimumFractionDigits: 0,
      numberingSystem: 'latn',
    }).format(lowest.PRICE)
  }
  return proxy.$t('free_shipping')
}

function getTransitDaysForMinimapPrice(svc) {
  const lowestPriceItem = svc.ITEMS.reduce((prev, curr) =>
    prev.PRICE < curr.PRICE ? prev : curr
  )
  if (lowestPriceItem.TRANSIT) {
    return (
      lowestPriceItem.TRANSIT +
      ' ' +
      declOfNumGlobal(lowestPriceItem.TRANSIT, proxy.$t('declDays'))
    )
  }
  return ''
}
</script>

<style lang="scss" scoped>
.delivery-type__item-info-title {
  line-height: 1rem;
}

.delivery-types-ukraine {
  .type-courier {
    order: 1 !important;
  }

  .delivery-type__item {
    order: 2;
  }
}

.delivery-type__item {
  display: flex;
  justify-content: normal;
  gap: 16px;
  padding: 16px;
  align-items: center;
  border-radius: 16px;
  border: 1px solid #e5ecf1;
  background: #ffffff !important;
  box-shadow:
    0 2px 2px -1px rgba(4, 8, 13, 0.08),
    0 2px 8px -1px rgba(4, 8, 13, 0.08);

  @media (max-width: 1280px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  @media (max-width: 1024px) {
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  &-icon {
    width: 32px;
    height: 32px;
  }

  &-info {
    display: flex;
    flex-direction: column;

    &-title {
      color: #39444c;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.224px;
      margin-bottom: 4px;
    }

    &-subtitle {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      color: #75828b;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.196px;

      .subtitle-comma {
        &:after {
          content: ',';
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
